module.exports = __webpack_public_path__ + "fonts/2a3831c.ttf";